export default __webpack_public_path__ + "004add2503b7a42dc4e0d895af4f4c8b.png";